import { DELIMITER, PREFIX } from "../ariaConstants";
import getItemId from "../../../../getItemId";

const orderedKeys = [
  "title",
  "stock",
  "price",
  "discount",
  "fulfilment",
  "sellingFast",
  "earlyAccessBadge"
];

const getAriaLabelledBy = ({ variantId, productId }) => {
  const productTileDistinctId = getItemId({ variantId, productId });
  const map = orderedKeys.reduce(
    (map, key, index) => ({
      ...map,
      [key]: `${PREFIX}-${productTileDistinctId}-${index}`
    }),
    {}
  );
  const labelledBy = Object.values(map).join(` ${DELIMITER} `);

  return {
    ...map,
    labelledBy
  };
};

export default getAriaLabelledBy;
